export const AXIS_COLOR_BY_KEY = {
  x: 0xef4444,
  y: 0x10dd10,
  z: 0x3b68ff,
} as const;

export const AXIS_COLOR_X = AXIS_COLOR_BY_KEY.x;
export const AXIS_COLOR_Y = AXIS_COLOR_BY_KEY.y;
export const AXIS_COLOR_Z = AXIS_COLOR_BY_KEY.z;
